// Matches literal `%E2%80%8B` (a URL-encoded zero-width space that has
// sometimes been pasted in verbatim), real whitespace, Unicode zero-width
// characters (U+200B-U+200D) and the byte-order mark (U+FEFF).
const SPACE_LIKE_CHARACTERS_PATTERN = '%E2%80%8B|[\\s\\u200B-\\u200D\\uFEFF]';

export function stripSpaceLikeCharacters(value: string): string {
  return value.replace(new RegExp(SPACE_LIKE_CHARACTERS_PATTERN, 'g'), '');
}

export function hasSpaceLikeCharacters(value: string): boolean {
  return stripSpaceLikeCharacters(value) !== value;
}

export function exceedsMaxLength(value: string, maxLength: number): boolean {
  return value.length > maxLength;
}
